import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "@mantine/core";
import { Chat } from "./Chat.js";
import { ChatList } from "./ChatList.js";
import { useChatHistoryOpen, useChatOpen } from "../../hooks/assistant.js";
const marginStyle = {
    border: "2px solid light-dark(black, white)",
    borderRadius: "12px",
    overflow: "hidden",
    backgroundColor: "light-dark(white, black)",
};
export const ChatView = () => {
    const chatOpen = useChatOpen();
    const historyOpen = useChatHistoryOpen();
    /**
     * We want to keep chat messages processing even if the chat is closed
     * In addition we use mapka-ai-view in header for positioning and we do not want unmount it
     */
    const display = historyOpen || chatOpen ? "flex" : "none";
    return (_jsxs(Flex, { h: "100%", flex: "1 1 0", id: "mapka-ai-view", style: marginStyle, display: display, children: [_jsx(ChatList, {}), _jsx(Chat, {})] }));
};
